export const dispatchDressipiTrackingAnalytics = (
  productId: string,
  skuId: string,
) => {
  if (typeof window !== "undefined" && window.Dressipi) {
    window.Dressipi("track", "pdp", {
      productCode: productId,
      skuId: skuId,
    });
  }
};

export const isMobile = () => window.innerWidth <= 767;
export const isTablet = () =>
  window.innerWidth > 767 && window.innerWidth < 1024;
export const isDesktop = () => window.innerWidth >= 1024;

export const dispatchDressipiDeviceTypeAnalytics = () => {
  const deviceType = isMobile()
    ? "smartphone"
    : isDesktop()
      ? "desktop"
      : isTablet()
        ? "tablet"
        : "other";

  if (typeof window !== "undefined" && window.Dressipi) {
    window.Dressipi("config", "set", "deviceType", deviceType);
  }
};
